import styled from 'styled-components'

export default styled.div`
  color: #72767d;
  font-size: ${props => props.fontSize ? props.fontSize : '14px'};
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
`
